import { render, staticRenderFns } from "./CustomPublishers.vue?vue&type=template&id=23f1fb84&scoped=true"
import script from "./CustomPublishers.vue?vue&type=script&lang=js"
export * from "./CustomPublishers.vue?vue&type=script&lang=js"
import style0 from "./CustomPublishers.vue?vue&type=style&index=0&id=23f1fb84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1fb84",
  null
  
)

export default component.exports